module.exports = __webpack_public_path__ + "img/in-tn.af661449.svg";